import React from 'react'
import {
    OverContainerSection,
    OverContainer,
    OverSpan,
    ContentTypography,
    TypographyHeader,
} from './styles'
import { TypographyContent } from 'src/components/common/Typography/typography'
interface Data {
    image: string
    title: string
    subTitle: string
}
export const Header = ({ subTitle, title, image }: Data) => {
    return (
        <>
            <OverContainerSection>
                <OverContainer
                    paddingBottom={['medium', 'medium', 'large', 'titlle']}
                    width={1}
                    image={image}
                />
                <OverSpan></OverSpan>
            </OverContainerSection>
            <OverContainerSection>
                <ContentTypography
                    marginTop={['xxxlarge', 'xxxlarge', 'xxxlarge', 'xsixty']}
                    marginBottom={[
                        'xxxlarge',
                        'xxxlarge',
                        'xxxlarge',
                        'xsixty',
                    ]}
                >
                    <TypographyHeader
                        variant={'h1'}
                        fontSize={[
                            'xxsuper',
                            'xxsuper',
                            'xxxtitle',
                            'xxxtitle',
                        ]}
                        fontWeight={700}
                    >
                        {title}
                    </TypographyHeader>
                    <TypographyContent
                        variant={'h2'}
                        fontSize={[
                            'xxxsmall',
                            'xxxsmall',
                            'xmedium',
                            'xmedium',
                        ]}
                        fontWeight={500}
                    >
                        {subTitle}
                    </TypographyContent>
                </ContentTypography>
            </OverContainerSection>
        </>
    )
}
